<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="760px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      :validate-on-rule-change="false"
      :model="ruleForm"
      :rules="rules"
      label-width="100px">
      <el-form-item label="资讯模式：">{{ ruleForm.contentType | ContentModeName() }}</el-form-item>
      <el-form-item
        label="资讯标题："
        prop="title">
        <el-input
          v-model="ruleForm.title"
          show-word-limit
          :maxlength="32"></el-input>
      </el-form-item>
      <el-form-item
        label="资讯来源："
        prop="source">
        <el-input
          v-model="ruleForm.source"
          show-word-limit
          :maxlength="20"></el-input>
      </el-form-item>
      <el-form-item
        label="发布时间："
        prop="createdTime">
        <el-date-picker
          v-model="ruleForm.createdTime"
          :editable="false"
          type="date"
          placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item
        label="资讯分组："
        prop="topic">
        <info-group-select v-model="ruleForm.topic" />
      </el-form-item>
      <el-form-item
        label="资讯首图："
        prop="image">
        <upload-with-crop
          v-model="ruleForm.image"
          :cropper="true"
          :isLt2M="500"
          :limit="1"
          :fixedNumber="[5,3]"
          :autoCropWidth="120"
          :autoCropHeight="72"></upload-with-crop>
      </el-form-item>
      <el-form-item
        label="排序值："
        prop="sort">
        <el-input-number
          v-model="ruleForm.sort"
          :precision="0"
          :min="1"
          :max="1000"></el-input-number>
      </el-form-item>
      <el-form-item
        v-if="ruleForm.contentType === 0"
        label="资讯详情："
        prop="content1">
        <desc-images
          v-model="ruleForm.content1"
          edit></desc-images>
      </el-form-item>
      <el-form-item
        v-if="ruleForm.contentType === 1"
        label="外部链接："
        prop="content">
        <el-input
          v-model="ruleForm.content"
          show-word-limit
          :maxlength="100"></el-input>
      </el-form-item>
      <el-form-item
        label="是否上架："
        prop="status">
        <el-switch
          v-model="ruleForm.status"
          :active-value="1"
          :inactive-value="0">
        </el-switch>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="visible = false">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import DescImages from '@/components/public/desc-images.vue'
import UploadWithCrop from '@/components/public/upload-with-crop.vue'
import InfoGroupSelect from './info-group-select.vue'
import Common from '@/service/common'
export default {
  name: 'EditInfoModal',
  components: { DescImages, UploadWithCrop, InfoGroupSelect },
  data() {
    return {
      loading: false,
      visible: false,
      ruleForm: { id: null, title: '', image: [], contentType: null, content1: [], content: null, status: 0, sort: 1, topic: null, source: '', createdTime: null },
      rules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        topic: [
          { required: true, message: '请选择分组', trigger: 'change' }
        ],
        image: [
          { required: true, message: '请上传首图', trigger: 'change' }
        ],
        content1: [
          { required: true, message: '请上传图片', trigger: 'change' }
        ],
        content: [
          { type: 'url', required: true, message: '请输入公众号文章链接', trigger: 'change' }
        ],
        source: [
          { required: true, message: '请输入资讯来源', trigger: 'blur' }
        ],
        createdTime: [
          { required: true, message: '请选择发布时间', trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '请输入排序数值', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    title({ ruleForm }) {
      return (ruleForm.id ? '编辑' : '新增') + '政策资讯'
    }
  },
  methods: {
    handleClosed() {
      this.ruleForm = { ...this.ruleForm, ...this.$options.data().ruleForm }
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const dispatch = this.ruleForm.id ? 'updateinfo' : 'addinfo'
          const { contentType, content, content1, image } = this.ruleForm
          Common[dispatch]({
            ...this.ruleForm,
            image: this.$stringfyImage(image),
            content: contentType === 0 ? this.$stringfyImage(content1) : content
          })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.$message.success('提交成功')
                this.visible = false
                this.$emit('fetch')
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.$message.error(err.message)
            })
        }
      })
    },
    init(options = {}) {
      this.ruleForm = { ...this.ruleForm, ...options }
      this.visible = true
    }
  }
}
</script>
